import React from 'react';

const FQ = () => {
    return (
        <div className="fq-main">
            <div className="container">
                <div className="row justify-content-center align-items-center">
                    <div className="col-md-2">
                        <div className="fq-left">
                            <img className="founder-img" src="/images/founder.jpg" alt="" />
                        </div>
                    </div>
                    <div className="col-md-10">
                        <div className="fq-cont">
                            <div className="d-flex flex-column">
                                <div className="quote">
                                    “ If You Are Working On Something That You Really Care About, You Don’t Have To Be Pushed, The Vision Pulls You. ”
                                </div>
                                <div className="author">
                                    - Sunil Kumar Shrivastava <br />
                                    Chairperson @ ATC
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FQ;
